import { useQuery } from "@tanstack/react-query";
import { getAccessToken, getRefreshToken, getTgAccessToken } from "src/api";
import { getUserNotifications } from "src/api/notify/notification";
import { PaginationData } from "src/types/api";
import { QUERYKEYS } from "src/types/queryKeys";

export const useGetNotifications = (payload: PaginationData) => {
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();
  const tgAccessToken = getTgAccessToken();
  const hasBrowserAuth = !!accessToken && !!refreshToken;
  const hasTgAuth = !!tgAccessToken;
  const { isLoading, isError, data, isSuccess, refetch } = useQuery({
    queryKey: [QUERYKEYS.NOTIFICATIONS, payload.page, payload.size],
    queryFn: () => getUserNotifications(payload),
    enabled: hasBrowserAuth || hasTgAuth,
    staleTime: 0,
  });

  return {
    isSuccess,
    data,
    isError,
    isLoading,
    refetchUserData: refetch,
  };
};
